import { Controller } from "@hotwired/stimulus"
import { render } from 'timeago.js'

// Connects to data-controller="timeago"
export default class extends Controller {
  connect() {
    document.querySelectorAll('time.timeago').forEach(el => render(el))
  }
}
